import { atomFamily, selector, selectorFamily } from "recoil";
import { COMMUNICATE_ERROR_MESSAGE_USER_CONFIG } from "../constants/ErrorMessage";
import { executeLinksAPI } from "../utils/LinksAPI";
import tabSyncEffect from "./effect/TabSyncEffect";

//user設定情報取得API
export const userConfigQuery = selector({
  key: 'userConfigQuery',
  get: async () => {
    // console.log("userConfigQuery get");
    const config = {
      method: 'get',
      errorHandle: {
        message: COMMUNICATE_ERROR_MESSAGE_USER_CONFIG
      }
    };
    return await executeLinksAPI('fosterlinks/user_config', config)
      .then(data => {
        return data;
      }).catch((error) => {
        console.error('user_config get failed.');
        throw error;
      });
  }
});

//user設定情報
export const userConfigState = atomFamily({
  key: 'userConfigState',
  default: selectorFamily({
    key: 'userConfigStateSelectorFamily',
    get: (key) => ({get}) => {
      const userConfig = get(userConfigQuery);
      if (key === 'theme') {
        return {
          theme_list: userConfig.theme_list,
          selected_theme_name: userConfig.selected_theme_name,
        };
      } else {
        return userConfig[key];
      }
    }
  }),
  effects: (key) => [
    tabSyncEffect(key)
  ]
});
